/**
 * Where did this person come from? On the very first page load we remember the referrer, the landing page and any
 * utm_* tags; once they are signed in we tell the server once, so the Telegram alerts ("new signup", "checkout started",
 * "purchase") can say "via google.com, landed on /practice/squat". Never blocks anything: every step is best effort.
 */
import { getSignupIntent } from "@/lib/intent";

const KEY = "formanti_first_touch";
const SENT = "formanti_first_touch_sent";

export function captureFirstTouch() {
  try {
    if (localStorage.getItem(KEY)) return;
    const q = new URLSearchParams(window.location.search);
    const ref = document.referrer || "";
    let host = "";
    try { host = ref ? new URL(ref).hostname.replace(/^www\./, "") : ""; } catch { host = ""; }
    if (host && host === window.location.hostname.replace(/^www\./, "")) host = "";   // our own site is not a source
    localStorage.setItem(KEY, JSON.stringify({
      landing: window.location.pathname.slice(0, 200),
      referrer: host.slice(0, 120),
      referrer_url: ref.slice(0, 300),
      utm_source: (q.get("utm_source") || "").slice(0, 80),
      utm_medium: (q.get("utm_medium") || "").slice(0, 80),
      utm_campaign: (q.get("utm_campaign") || "").slice(0, 120),
      at: new Date().toISOString(),
    }));
  } catch { /* private mode: no attribution, nothing else lost */ }
}

/** Tell the server about the first touch, once per signed-in account on this device. */
export async function sendAcquisitionOnce(api, userId) {
  try {
    if (!userId || localStorage.getItem(SENT) === userId) return;
    const raw = localStorage.getItem(KEY);
    if (!raw) return;
    // what brought them to sign up (Practice, Analyze, a sport page...): trackSignup froze it; else work it out now
    let intent = null;
    try { intent = JSON.parse(localStorage.getItem("formanti_signup_final") || "null"); } catch { intent = null; }
    if (!intent) intent = getSignupIntent();
    await api.post("/auth/acquisition", { ...JSON.parse(raw), intent: intent.feature, intent_detail: intent.detail, intent_source: intent.source }, { timeout: 8000 });
    localStorage.setItem(SENT, userId);
  } catch { /* try again next time */ }
}
